import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import Layout from '../../components/layouts/Layout'
import http, { URL_S3 } from '../../config/BaseUrl'
import EmailTemplate from '../events/components/Modal/EmailTemplate'
import ScreenLoader from '../../components/Loader/ScreenLoader'

const EmailEdit = () => {

    const { register, handleSubmit, reset } = useForm({
        mode: "all",
        reValidateMode: "onChange",

    });

    const history = useHistory()
    const { id } = useParams()
    const [loading, setLoading] = useState(false);
    const [emailTemplate, setTemplate] = useState(null)
    const [emailUpdate, setEmailUpdate] = useState(null)
    const [email_my_template_id, setEmailMyTemplateId] = useState(null)
    const [emailTemplateType, setEmailTemplateType] = useState(null)
    const [emailTemplateContents, setEmailTemplateContents] = useState(null)
    const [eventId, setEventId] = useState(null)

    useEffect(() => {
        http.get(`get-email-settings-data/${id}`)
            .then(res => {
                setEventId(res.data.emailSetting.event_id)
                setEmailUpdate(res.data.emailSetting);
                reset({
                    from_name: res.data.emailSetting.from_name,
                    reply_to: res.data.emailSetting.reply_to,
                    email_subject: res.data.emailSetting.email_subject,
                })

                if (typeof history.location.state != "undefined" && "editedData" in history.location.state) {
                    const theData = history.location.state.editedData
                    setEmailUpdate({email_template_id: theData.template.id, email_template:theData.template.image})
                    setEmailTemplateType(theData.saveAs)
                    setEmailTemplateContents(theData.content)
                    if (theData.saveAs == 'my_template') {
                        setEmailMyTemplateId(theData.email_my_template_id)
                    }
                    else{
                        setEmailMyTemplateId(null)
                    }
                }
            })
    }, [])

    useEffect(() => {
        if (emailUpdate) {
            setTemplate({ id: emailUpdate.email_template_id, image: emailUpdate.email_template })
        }
    }, [emailUpdate])



    const handelEmailUpdate = async (data) => {
        const submittedData = { ...data, email_template: emailTemplate.image, email_template_id: emailTemplate.id, template_type: emailTemplateType, email_my_template_id, contents: emailTemplateContents }
        try {
            setLoading(true)
            await http.post(`/event/email/update/${id}`, submittedData)
                .then(res => {
                    setLoading(false)
                    history.push(`/show/event/${eventId}`, 'Information Updated.')
                })
        } catch (error) {
            console.log(error)
        }

    }

    const setEmailTemplateByProps = (data) => {
        
        if ('contents' in data) {
            setTemplate({id: data.id, image: data.image})
            setEmailTemplateContents(data.contents)
            setEmailTemplateType('my_template')
            setEmailMyTemplateId(data.email_my_template_id)
        }
        else{
            setTemplate(data)
        }
    }


    useEffect(()=>{
        if (typeof history.location.state != "undefined" && "editedData" in history.location.state) {
            const theData = history.location.state.editedData
            setEmailUpdate({email_template_id: theData.template.id, email_template:theData.template.image})
            setEmailTemplateType(theData.saveAs)
            setEmailTemplateContents(theData.content)
            if (theData.saveAs == 'my_template') {
                setEmailMyTemplateId(theData.email_my_template_id)
            }
            else{
                setEmailMyTemplateId(null)
            }
        }
    }, [history])


    return (
        <Layout>
            <NewFormWizard />
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="pb-4">
                                            <p className="mb-0 display-4 text-primary event-form-title">Email Settings</p>
                                            <p className="mb-0 text-secondary">Setup email sharing for your event</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(handelEmailUpdate)} >
                    <div className="row justify-content-center">
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-body" style={{ minHeight: '330px' }}>
                                    <div className="row">
                                        <div className="col-sm-6 d-flex align-items-center flex-column justify-content-center">
                                            <div className="place-holder-section">
                                                {
                                                    !emailTemplate ?
                                                        <div className="default-section">
                                                            <h4>Choose Email Template.</h4>
                                                        </div>
                                                        :
                                                        <div className="default-section">
                                                            <img src={`${URL_S3}image/email_template/${emailTemplate.image}`} className="img-fluid" alt="email-template" />
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <button type="button" className="btn btn-primary btn-block" data-toggle="modal" data-target="#email-template">Template Library</button>

                                            <EmailTemplate setData={setEmailTemplateByProps} email_id={id} oldItem={emailUpdate && emailUpdate.email_template_id} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label htmlFor="">From Name</label>
                                        <input type="text" className="form-control" {...register("from_name")} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Reply To</label>
                                        <input type="text" className="form-control" {...register("reply_to")} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="">Email Subject</label>
                                        <input type="text" className="form-control" {...register("email_subject")} />
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="" className="col-sm-6 col-form-label">Send</label>
                                        <div className="col-md-6">
                                            <select className="form-control" {...register("send")}  >
                                                <option value="1">Social Gallery link</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-30">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default EmailEdit
